const duplicatePetals = {
    $contentWrap: $('.js-content-wrap'),
    $petalsWrap: $('.js-petals-wrap'),
    $petalsHtml: $('.js-petals-group').html(),
    init: function () {
        if (this.$contentWrap.length && this.$petalsWrap.length) {
            this.compareHeights()
        }
    },
    compareHeights: function () {
        while (
            this.getBottomPos(this.$contentWrap) >
            this.getBottomPos(this.$petalsWrap)
        ) {
            let $newGroup = $('<div class="petals-group"></div>')
            $newGroup.html(this.$petalsHtml)
            this.$petalsWrap.get(0).append($newGroup.get(0))
        }
        $(document).trigger('update:petalsCount')
    },
    getBottomPos: function ($wrapper) {
        return $wrapper.offset().top + $wrapper.height()
    },
}

duplicatePetals.init()
